// replicamos el nombre de las entidades
const TRAIN_DETAI = 'train-detail'
const AIR_DETAIL = 'air-detail'


export {
    TRAIN_DETAI,
    AIR_DETAIL
}